import request from '@/util/request'
import {
  JSON_CONFIG,
  getAPILangParam
} from '@/util/helper.js'

export function getCurrentExercises (patientId) {
  return request({
    url: `/patient/${patientId}/schedule/current`,
    method: 'get',
    header: JSON_CONFIG,
    params: {
      lang: getAPILangParam()
    }
  })
}

export function updateCurrentExercises (patientId, requestBody) {
  return request({
    url: `/patient/${patientId}/schedule/current`,
    method: 'post',
    header: JSON_CONFIG,
    data: requestBody
  })
}

export function removeAdjustExercises (patientId) {
  return request({
    url: `/patient/${patientId}/schedule/current`,
    method: 'delete',
    header: JSON_CONFIG
  })
}

export function unlock (patientId, timestamp, withArg = false) {
  // TODO: 可以考慮有沒有更好的方法
  const params = {
    time: timestamp
  }
  if (withArg) {
    params.upgrade = patientId
  }
  return request({
    url: `/patient/${patientId}/unlock`,
    method: 'get',
    header: JSON_CONFIG,
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/patient/currentExercises.js